import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-facility-mobile-filter',
  templateUrl: './facility-mobile-filter.component.html',
  styleUrls: ['./facility-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class FacilityMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  facilityName: string | null = null;
  state: string | null = null;
  county: string | null = null;
  township: string | null = null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      facilityName: this.facilityName,
      state: this.state,
      county: this.county,
      township: this.township,
    });
  }

  clear() {
    this.facilityName = null;
    this.state = null;
    this.county = null;
    this.township = null;
    this.mobileFilter();
  }
}
